import { useCallback } from 'react';

import * as server from '../server';

export const useGetTransactionHistory = () => {
    return useCallback(async ({
        type,
        status,
        startTime,
        endTime,
        corrections,
        cancellations
    }) => {
        const response = await server.getTransactionHistory({
            type,
            status,
            startTime,
            endTime,
            corrections,
            cancellations
        });

        const {
            payments = {},
            maxResultsExceeded = {}
        } = response?.data ?? {};

        return {
            payments,
            maxResultsExceeded
        };
    }, []);
};
